import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OpenthreadDashboardComponent } from './openthread-dashboard.component';
import { DevicesComponent } from './pages/devices/devices.component';
import { EventsComponent } from './pages/events/events.component';

const routes: Routes = [
  { path: '', component: OpenthreadDashboardComponent },
  { path: 'devices', component: DevicesComponent },
  { path: 'events', component: EventsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OpenthreadDashboardRoutingModule { }
